import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import PrivateRoutes from './routes/PrivateRoutes';
import { Provider } from 'react-redux';
import { store } from './redux/store'
import RunLTAnalytics from './pages/LT/RunLTAnalytics/RunLTAnalytics';
import AnalyticsResults from './pages/LT/analyticsresults/AnalyticsResults';
import ErrorPage from './pages/ErrorPage';
import ActionDashboard from './pages/LT/ActionDashboard/actionDashboard';
import WorkflowManagement from './pages/LT/WorkflowManagement';
import SchedulerConfigurator from './pages/LT/SchedulerConfigurator';
import LandingPage from './pages/LandingPage/LandingPage';
import AnalyticsResultsTab from './pages/LT/analyticsresults/AnalyticsResultsTab';
import ParamaterConfiguration from './pages/LT/ParameterConfiguration';
import PlannerMaterialMapping from './pages/LT/PlannerMaterialMapping';
import UserAuthorization from './pages/LT/UserAuthorization';
import PriceMemo from './pages/MDM/PriceMemo';
import Contracts from './pages/MDM/Contracts';
import RunAnalyticsScheduler from './pages/LT/RunAnalyticsScheduler';
import DataErrors from './pages/MDM/PriceMemo/DataErrors';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth/msalConfig';
import ApproverManagement from './pages/LT/Approver';
import ApproverResultsDetails from './pages/LT/Approver/ApproverResultsDetails';
import AdminAnalyticsResults from './pages/LT/analyticsresults/AdminAnalyticsResults';
import AdminAnalyticsResultsTab from './pages/LT/analyticsresults/AdminAnalyticsResultsTab';
import OutBoundDataSync from './pages/LT/OutBound/OutBoundDataSync';
import DPSLTAnalyticsResults from './pages/LT/DPSLT/DPSLTAnalyticsResults';
import DPSLTAnalyticsResultsDetails from './pages/LT/DPSLT/DPSLTAnalyticsResultsDetails';
import DPSPlannerAnalyticsResults from './pages/LT/DPSPlanner/DPSPlannerAnalyticsResults';
import DPSPlannerAnalyticsResultsDetails from './pages/LT/DPSPlanner/DPSPlannerAnalyticsResultsDetails';
import { Reporting } from './pages/MDM/Reporting';
import PlannerOutBoundDataSync from './pages/LT/PlannerOutBoundSync/PlannerOutBoundDataSync';
import PowerBIReports from './pages/PowerBIReports';
import ViewerAnalyticsResults from './pages/LT/analyticsresults/ViewerAnalyticsResults';
import ViewerAnalyticsResultsTab from './pages/LT/analyticsresults/ViewerAnalyticsResultsTab';
import GMPActionDashboard from './pages/LT/ActionDashboard/GMPActionDashboard';
import GMPLTAnalyticsResults from './pages/LT/analyticsresults/GMPLTAnalyticsResults';
import GMPAnalyticsResultsTab from './pages/LT/analyticsresults/GMPAnalyticsResultsTab';
import GMPPlannerOutBoundDataSync from './pages/LT/PlannerOutBoundSync/GMPPlannerOutBoundDataSync';
import ContractMaintenance from './pages/MDM/ContractMaintenance';
import NewContract from './pages/MDM/ContractMaintenance/NewContract';
import UpdateContract from './pages/MDM/ContractMaintenance/UpdateContract';
import NewYearContractReports from './pages/MDM/NewYearContractReports';
import KPIScreens from './pages/KPIScreens';
import TicketSummary from './pages/MDM/TicketSummary';
import LTTicketSummary from './pages/LT/LTTicketSummary';
import PriceMemoMaintenance from './pages/MDM/PriceMemoMaintenance';
import Dashboard from './pages/MDM/Dashboard';
import ARDashboard from './pages/Ariba/ARDashboard';
import { PriceMemoManagement } from './pages/MDM/PriceMemoManagement';
import { AuditLogs } from './pages/MDM/AuditLogs';
import { PackViewerPriceMemo } from './pages/MDM/PriceMemoManagement/PackViewerPriceMemo';
import AutoTargetValue from './pages/MDM/ContractMaintenance/AutoTargetValue';
import InventoryImpactSimulation from './pages/LT/InventoryImpactSimulation';
import QuotaMaintenance from './pages/MDM/QuotaMaintenance';
const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

document.title = process.env.REACT_APP_PAGE_TITLE;

const observerError = "ResizeObserver loop completed with undelivered notifications.";
window.addEventListener("error", (e) => {
  if (e.message === observerError) {
    e.stopImmediatePropagation();
  }
});

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Provider store={store}>
        <App />
      </Provider>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "landing-page",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <LandingPage />,
          },
        ],
      },
      {
        path: "lt-dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ActionDashboard />,
          },
        ],
      },
      {
        path: "run-analytics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <RunLTAnalytics />,
          },
        ],
      },
      {
        path: "material_details",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AnalyticsResultsTab />,
          },
        ],
      },
      {
        path: "analytics-results",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AnalyticsResults />,
          },
        ],
      },
      {
        path: "workflowManagement",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <WorkflowManagement />,
          },
        ],
      },
      {
        path: "DPS-analytics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <DPSLTAnalyticsResults />,
          },
        ],
      },
      {
        path: "DPS-analytics-Details",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <DPSLTAnalyticsResultsDetails />,
          },
        ],
      },
      {
        path: "DPS-Planner-analytics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <DPSPlannerAnalyticsResults />,
          },
        ],
      },
      {
        path: "DPS-Planner-analytics-Details",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <DPSPlannerAnalyticsResultsDetails />,
          },
        ],
      },
      {
        path: "s4datasyncstatus",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <OutBoundDataSync />,
          },
        ],
      },
      {
        path: "s4datasyncstatus-planner",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PlannerOutBoundDataSync />,
          },
        ],
      },
      {
        path: "scheduler-configurator",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <SchedulerConfigurator />,
          },
        ],
      },
      {
        path: "parameter-configuration",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ParamaterConfiguration />,
          },
        ],
      },
      {
        path: "planner-material-mapping",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PlannerMaterialMapping />,
          },
        ],
      },
      {
        path: "user-authorization",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <UserAuthorization />,
          },
        ],
      },
      {
        path: "price-memo",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PriceMemo />,
          },
        ],
      },
      {
        path: "contracts",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <Contracts />,
          },
        ],
      },
      {
        path: "reportings",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <Reporting />,
          },
        ],
      },

      {
        path: "run-analytics-scheduler",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <RunAnalyticsScheduler />,
          },
        ],
      },
      {
        path: "price-memo/data-errors",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <DataErrors />,
          },
        ],
      },
      {
        path: "contract-maintenance",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ContractMaintenance />
          },
        ],
      },
      {
        path: "contract-maintenance/new-contract",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <NewContract />,
          },
        ],
      },
      {
        path: "contract-maintenance/update-contract",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <UpdateContract />,
          },
        ],
      },
      {
        path: "contract-maintenance/review-auto-target-value",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AutoTargetValue />,
          },
        ],
      },
      {
        path: "cm-reports",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <NewYearContractReports />,
          },
        ],
      },
       {
        path: "quota-maintenance",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <QuotaMaintenance />,
          },
           {
            path: "results",
            element: <QuotaMaintenance />,
          },
        ],
      },
      {
        path: "ticket-summary",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <TicketSummary />,
          },
        ],
      },
      {
        path: "pricememo-management",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PriceMemoManagement />,
          },
        ],
      },
      {
        path: "audit-logs",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AuditLogs />,
          },
        ],
      },
      {
        path: "packaging-viewer-pricememo",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PackViewerPriceMemo />,
          },
        ],
      },
      {
        path: "cd-dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <Dashboard />,
          },
        ],
      },
      {
        path: "approval-management",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ApproverManagement />,
          },
        ],
      },
      {
        path: "detailed-results-approval",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ApproverResultsDetails />,
          },
        ],
      },
      {
        path: "admin-analytics-results",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AdminAnalyticsResults />,
          },
        ],
      },
      {
        path: "admin-analytics-results-details",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AdminAnalyticsResultsTab />,
          },
        ],
      },
      {
        path: "viewer-analytics-results",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ViewerAnalyticsResults />,
          },
        ],
      },
      {
        path: "viewer-analytics-results-details",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ViewerAnalyticsResultsTab />,
          },
        ],
      },
      {
        path: "reports",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PowerBIReports />,
          },
        ],
      },
      {
        path: "gmp-dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <GMPActionDashboard />,
          },
        ],
      },
      {
        path: "gmp-analytics-results",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <GMPLTAnalyticsResults />,
          },
        ],
      },
      {
        path: "gmp-analytics-results-details",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <GMPAnalyticsResultsTab />,
          },
        ],
      },
      {
        path: "gmp-s4datasyncstatus",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <GMPPlannerOutBoundDataSync />,
          },
        ],
      },
      {
        path: "ar-dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ARDashboard />,
          },
        ],
      },
      {
        path: "kpi-tracking",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <KPIScreens />,
          },
        ],
      },
      {
        path: "lt-ticketsummary",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <LTTicketSummary />,
          },
        ],
      },
      {
        path: "inventory-impact-simulation",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <InventoryImpactSimulation />,
          },
        ],
      },
      {
        path: "pricememo-maintenance",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <PriceMemoMaintenance/>,
          },
        ],
      },
    ],
  },

]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <RouterProvider router={router} />
    </MsalProvider>
  </React.StrictMode>
);
reportWebVitals();
